import Fade from 'react-reveal/Fade';
import photo from '../img/photo.jpg'
import resume from '../files/Jacob Yoon Resume.pdf';

export default function About() {
    return (
        <Fade>
            <div className="About section" id="about">
                <h2><Fade top><div>About Me</div></Fade></h2>
                <div className="a">
                    <img src={photo} alt="" />
                    <div className="b">
                        <p className="txt">Hi there! I'm a developer, designer, and artist currently based in Ithaca, NY. I'm a first year student at Rochester Institute of Technology studying computer science and physics. But despite my focus on these fields, I have deep passions in the arts. From my 10 years of being a classical oboist to my obsessions with fashion and 3D art, it's my artistic side that makes me a unique engineer. I aim to use my technical skills as a programmer and mathematician to make my artistic dreams a reality.</p>
                        <Fade top><a href={resume} target="_blank" className="button">
                            <span className="textouter">
                                <span className="text" data-text="Résumé">Résumé</span>
                            </span>
                        </a></Fade>
                    </div>
                </div>
                <h3><Fade top><div>Skills and Interests</div></Fade></h3>
                <ul>
                    <li>Python</li>
                    <li>Java</li>
                    <li>C#</li>
                    <li>C++</li>
                    <li>C</li>
                    <li>HTML/CSS/JS</li>
                    <li>React.js</li>
                    <li>Node.js</li>
                    <li>HLSL</li>
                    <li>Illustrator</li>
                    <li>Photoshop</li>
                    <li>Indesign</li>
                    <li>Adobe XD</li>
                    <li>Blender</li>
                    <li>Unity3D</li>
                    <li>Unreal Engine</li>
                </ul>
                <hr />
                <ul>
                    <li>Front-end Development</li>
                    <li>Web Development</li>
                    <li>Graphic Design</li>
                    <li>Layout Design</li>
                    <li>Game Development</li>
                    <li>3D Art</li>
                    <li>Illustration</li>
                    <li>Photography</li>
                    <li>Music Production</li>
                    <li>Oboe</li>
                    <li>Piano</li>
                    <li>Fashion</li>
                </ul>
            </div>
        </Fade>
    )
}